import { use as reduxUse, configureStore, getServiceVersion } from '@wappsto/redux';
import { setDefaultStreamOptions } from '@wappsto/blanket';
import { SUBSCRIPTIONS_YEARLY_STATE } from 'util/params';
import Cookies from 'util/cookies';

reduxUse({
  baseUrl: '/services',
  serviceVersion: {
    default: '2.1',
  },
});

const streamServiceVersion = getServiceVersion('stream');

// Initializing default state
const store = configureStore({ items: { [SUBSCRIPTIONS_YEARLY_STATE]: true } });

setDefaultStreamOptions({
  version: streamServiceVersion,
  endPoint: 'websocket',
});

export const SUPPORTED_LNGS = [
  'bg',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'hr',
  'hu',
  'it',
  'lt',
  'lv',
  'mk',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sr',
  'sv',
];

export const LINKS = {
  seluxit: 'https://www.seluxit.com',
  terms: 'https://www.seluxit.com/seluxit-cloud-terms',
  privacy: 'https://www.seluxit.com/privacy',
  emsSetup: 'https://energy.seluxit.com/getting-started',
  learnToSave: 'https://www.seluxit.com/learntosave',
  wappsto_about: 'https://wappsto.seluxit.com',
  wappsto_documentation: 'https://wappsto.seluxit.com/documentation',
  wappsto_getStarted: 'https://wappsto.seluxit.com/get-started',
  wappsto_native_google: 'https://play.google.com/store/apps/details?id=com.wappsto_native',
  wappsto_native_apple: 'https://apps.apple.com/dk/app/id1482236314',
  stripe_privacy: 'https://stripe.com/en-gb-dk/privacy',
  cookieNotice: 'https://www.cookiesandyou.com/',
  users: '/users',
  account: '/account',
  pricing: '/pricing',
  wallet: '/wallet',
  dashboards: '/dashboards',
  newDashboard: '/newdash',
  network: '/network',
  devices: '/devices',
  oauth: '/oauth',
  wapps: '/wapps',
  activeSubscription: '/wallet/activeSubscription',
  pointUsage: '/wallet/pointUsage',
  paymentHistory: '/wallet/paymentHistory',
  historicalCleanup: '/settings/historicalCleanup',
  changeUserDetails: '/account/changeUserDetails',
  settings: '/settings',
  store: '/store',
  support: '/support',
  whatsnew: '/whatsnew',
  login: '/login',
  registration: '/register',
  recoverPassword: '/recoverPassword',
  confirm: '/confirm',
  subscriptions: '/subscriptions',
};

export function getWappKey(key) {
  let result = window.sessionStorage.getItem(key);
  if (!result) {
    result = Cookies.read(key);
  }
  return result;
}

export default store;
